import { __decorate } from "tslib";
import { customElement } from '@here/hds-base';
import { Checkbox } from '@here/hds-checkbox';
import { query } from 'lit/decorators.js';
import { styles } from './hds-toggle.css.js';
let Toggle = class Toggle extends Checkbox {
    static get styles() {
        return [super.styles, styles];
    }
    firstUpdated() {
        this.checkboxWrapper.classList.add('-hds-toggle-wrapper');
    }
};
__decorate([
    query('.-hds-checkbox-wrapper')
], Toggle.prototype, "checkboxWrapper", void 0);
Toggle = __decorate([
    customElement('hds-toggle')
], Toggle);
export { Toggle };
//# sourceMappingURL=hds-toggle.js.map